import script from "./ChecklistExclusaoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ChecklistExclusaoPage.vue?vue&type=script&setup=true&lang=js"

import "./ChecklistExclusaoPage.vue?vue&type=style&index=0&id=11ff1c93&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ff1c93"]])

export default __exports__